import SMHoursTable from './SMHoursTable';

export default SMHoursTable;
